import firebase from "firebase/compat/app";

const setNewChallenge = async function(item) {
  let db = firebase.firestore();
  let result;
  if (item.name != undefined) {
    result = await db.collection("wellness_competition").add(item);
  }
  return result;
};

export default setNewChallenge;
